import { Box, Button, Switch } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // ✅ Import necesario
import Partidos from "../components/Partidos";
import Resultados from "../components/Resultados";
import Posiciones from "../components/Posiciones";
import logo from "../assests/images/logo_suenos_basquet_sin_fondo.png";
import Footer from "../components/Footer";

const HomeBasquet = () => {
  const [pageSelected, setPageSelected] = useState("partidos");
  const [activo, setActivo] = useState(false);
  const navigate = useNavigate(); // ✅ Hook para redirigir

  function cambiarVista() {
    setPageSelected((prev) =>
      prev === "partidos" ? "resultados" : "partidos"
    );
  }

  useEffect(() => {
    let intervalo;
    if (activo) {
      intervalo = setInterval(() => {
        cambiarVista();
        console.log("Cambio automático de vista");
      }, 60000);
    }
    return () => clearInterval(intervalo);
  }, [activo]);

  const handleSwitch = () => setActivo(!activo);

  return (
    <Box sx={{ marginX: 5 }}>
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        {/* ✅ Logo clickeable que lleva al home */}
        <img
          src={logo}
          alt="logo cuna de campeones"
          width="140px"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/")}
        />

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Switch checked={activo} onChange={handleSwitch} />
        </Box>
      </Box>

      {/* NAV BOTONES */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          marginBottom: 3,
        }}
      >
        <Button
          variant={pageSelected === "partidos" ? "contained" : "outlined"}
          color={pageSelected === "partidos" ? "primary" : "error"}
          onClick={() => setPageSelected("partidos")}
        >
          Partidos
        </Button>
        <Button
          variant={pageSelected === "resultados" ? "contained" : "outlined"}
          color={pageSelected === "resultados" ? "primary" : "error"}
          onClick={() => setPageSelected("resultados")}
        >
          Resultados
        </Button>
        <Button
          variant={pageSelected === "posiciones" ? "contained" : "outlined"}
          color={pageSelected === "posiciones" ? "primary" : "error"}
          onClick={() => setPageSelected("posiciones")}
        >
          Posiciones
        </Button>
      </Box>

      {/* CONTENIDO PRINCIPAL */}
      {pageSelected === "partidos" ? (
        <Partidos modoAuto={activo} />
      ) : pageSelected === "resultados" ? (
        <Resultados modoAuto={activo} />
      ) : (
        <Posiciones modoAuto={activo} />
      )}

      {/* FOOTER */}
      <Footer />
    </Box>
  );
};

export default HomeBasquet;
